import { ITab } from '../types/customizer';

interface SelectedOption {
  url: string;
  text: string;
  engravingText?:string;
}

export const getSelectedOption: any = (page: ITab) => {
  if (['outsideFeature_1', 'outsideFeature_2'].includes(page.eventKey)) {
    let optionToBeDisplayed = '';
    if (page.selectedFeature === 'Inlay') {
      optionToBeDisplayed = 'Material';
    } else if (page.selectedFeature === 'Design Pattern') {
      optionToBeDisplayed = 'Pattern';
    } else if (page.selectedFeature === 'Gemstone') {
      optionToBeDisplayed = 'Color';
    } else if (page.selectedFeature === 'All Cerakote') {
      optionToBeDisplayed = 'Color';
    }
    const selectedOption =
      page?.items?.find((item) => item?.title === optionToBeDisplayed)?.content
        ?.selectedOption || {};
    return {
      url: selectedOption?.swatch_url || '/swatches/settings/N/images/1',
      text: selectedOption?.name || 'None',
    };
  }
  if (page?.items?.length) {
    return page?.items?.reduce(
      (acc: SelectedOption, item: ITab) => {
        if (item?.items?.length) {
          return getSelectedOption(item);
        }
        if (page?.eventKey === 'shape' && item?.title === 'Weight') {
          return acc;
        }
        const selectedOption = item?.content?.selectedOption || {};
        const engravingText = item?.content?.engravingText || acc.engravingText;

        let url = acc?.url || '';
        if (!url && selectedOption?.swatch_url) {
          url = selectedOption?.swatch_url;
        }
        return {
          url,
          text: selectedOption?.name
            ? `${acc?.text ? `${acc.text} - ` : ''}${
                page?.eventKey === 'shape' && item?.title === 'Profile'
                  ? selectedOption?.short_name
                  : selectedOption.name
              }`
            : acc?.text,
          engravingText
        };
      },
      {
        url: '',
        text: '',
      }
    );
  } else {
    return {
      url: page?.content?.selectedOption?.swatch_url || '',
      text: page?.content?.selectedOption?.name || '',
    };
  }
};
